import React, { ComponentProps, JSX } from 'react';
import { Heading } from '@chakra-ui/react';

export const ChildPageHeading = ({ ...props }: ComponentProps<typeof Heading>): JSX.Element => (
  <Heading mb={2} fontSize={'24px'} fontFamily={'Rubik'} fontWeight={'bold'} {...props}>
    {props.children}
  </Heading>
);
